import { WikiArticleEntity } from "@/mk2/apps/wiki/schemas";
import { wikiArticleExperiencePhotoUrl, wikiArticlePhotoUrl } from "@/mk2/apps/wiki/urls";
import { url } from "@/mk2/helpers/urls";
import { PhotoEntity } from "@/mk2/schemas";

export interface ArticleGalleryItem {
    photofile: PhotoEntity;
    experienceId: number | null; // null => article photo
}

// Ordered, deduped merged gallery shown on review product pages: ALL article
// photos first (cover included, experienceId=null), then photos of approved &&
// !deleted experiences in article.experiences order, deduped by photofile.id
// (article photo wins; on cross-experience dupes the first experience wins).
// Degrades by data: an article without experiences yields article.photos only.
export function buildArticleGalleryPhotos(
    article: Pick<WikiArticleEntity, "photos" | "experiences">,
): ArticleGalleryItem[] {
    const items: ArticleGalleryItem[] = (article.photos ?? []).map((photofile) => ({
        photofile,
        experienceId: null,
    }));

    const seenPhotoIds = new Set(items.map((item) => item.photofile.id));
    for (const experience of article.experiences ?? []) {
        if (!experience.approved || experience.deleted) {
            continue;
        }
        for (const experiencePhoto of experience.photos ?? []) {
            const photofile = experiencePhoto.photofile;
            if (seenPhotoIds.has(photofile.id)) {
                continue;
            }
            seenPhotoIds.add(photofile.id);
            items.push({ photofile, experienceId: experience.id });
        }
    }

    return items;
}

// Detail URL for a gallery item, routed by its origin.
export function galleryItemLinkTo(
    article: Pick<WikiArticleEntity, "category" | "slug">,
    item: ArticleGalleryItem,
): string {
    if (item.experienceId !== null) {
        return url(wikiArticleExperiencePhotoUrl, {
            categorySlug: article.category.slug,
            articleSlug: article.slug,
            experienceId: item.experienceId,
            photoId: item.photofile.id,
        });
    }
    return url(wikiArticlePhotoUrl, {
        categorySlug: article.category.slug,
        articleSlug: article.slug,
        photoId: item.photofile.id,
    });
}
